import { FC } from 'react';
import { styled, useTheme } from '@mui/material/styles';

import Typography from '../Typography';
import { NonIdealStateProps } from './types';

const NonIdealState: FC<React.PropsWithChildren<NonIdealStateProps>> = ({
  children,
  fillColor,
  icon,
  title,
}) => {
  const theme = useTheme();

  return (
    <Wrapper>
      <IconWrapper fillColor={fillColor || theme.palette.colors.purple[500]}>
        {icon}
      </IconWrapper>
      <Typography variant='font16Bold' color={theme.palette.colors.grey[700]}>
        {title}
      </Typography>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 326px;
  text-align: center;
`;

const IconWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'fillColor',
})<{ fillColor: string }>`
  align-items: center;
  background-color: ${p => p.theme.palette.colors.purple[100]};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  height: 90px;
  justify-content: center;
  margin-bottom: 16px;
  padding: 18px;
  width: 90px;

  > svg {
    fill: ${p => p.fillColor};
    height: 100%;
    width: 100%;
  }
`;

export default NonIdealState;
